//const Apiurl = "http://192.168.1.103:8000/api";
  const Apiurl = "https://bs.aalantechsoft.com:8016/api";

export default Apiurl;
